<template>
  <div class="regions-row regions-row--skeleton">
    <div
      v-for="i in 6"
      :key="`skeleton-${i}`"
      class="skeleton-card-wrap"
    >
      <SkeletonItem class="skeleton-img" />
      <SkeletonItem class="skeleton-text" />
    </div>

    <div class="skeleton-more-wrap">
      <SkeletonItem class="skeleton-more-img" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';
</script>

<style scoped lang="scss">
  .regions-row.regions-row--skeleton {
    display: grid;
    grid-template: 1fr / repeat(7, 140px);
    gap: 0 8px;
    overflow-x: scroll;
    margin: 32px -20px;
    padding: 0 20px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .skeleton-card-wrap {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .skeleton-img {
    width: 140px;
    height: 112px;
    border-radius: 8px;
  }

  .skeleton-text {
    width: 105px;
    height: 14px;
    border-radius: 8px;
  }

  .skeleton-more-wrap {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .skeleton-more-img {
    width: 88px;
    height: 112px;
    border-radius: 8px;
  }
</style>
